export default {"src":"/_next/static/media/users-profiles.08d22fb1.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};